/**
 * HeroTerritories — navigation territoires du Hero cinématographique.
 *
 * Les 5 territoires de la maison (ensemble FERMÉ — directive mission) dans
 * l'ordre des plans du master vidéo. L'indicateur actif SUIT la vidéo
 * automatiquement (aucun système à clic) ; les territoires disposant d'une
 * page pilier « Implantations » sont également des liens — LOT 2 (CLÔTURE
 * BACKLOG) : les CINQ territoires ont désormais une route réelle, le Sud de
 * la France pointe vers sa page « marché en développement ».
 */
import { Link } from 'react-router-dom';
import { localizedPath } from '../../i18n/routes';

export const HERO_TERRITORIES = [
  { id: 'dubai', fr: ['Dubaï', 'Émirats arabes unis'], en: ['Dubai', 'United Arab Emirates'], pageKey: 'implantationDubai' },
  { id: 'andorre', fr: ['Andorre', 'Andorre'], en: ['Andorra', 'Andorra'], pageKey: 'implantationAndorre' },
  { id: 'algarve', fr: ['Algarve', 'Portugal'], en: ['Algarve', 'Portugal'], pageKey: 'implantationAlgarve' },
  { id: 'bali', fr: ['Bali', 'Indonésie'], en: ['Bali', 'Indonesia'], pageKey: 'implantationBali' },
  { id: 'sud_france', fr: ['Sud de la France', 'France'], en: ['South of France', 'France'], pageKey: 'implantationSudFrance' },
];

/* Débuts de plan du master (fractions de la durée totale) — valeurs RÉELLES
   écrites par scripts/assemble_hero_master.py (750 frames / 25 s / 5 plans,
   crossfades 1 s, bascule perçue au milieu du fondu). */
export const MASTER_SEGMENTS = [0, 0.18, 0.38, 0.58, 0.78];

export function territoryIndexAt(t, duration, segments = MASTER_SEGMENTS) {
  if (!duration || !Number.isFinite(t)) return 0;
  const f = (t % duration) / duration;
  // Toute fin de boucle : le crossfade final ramène le plan d'ouverture
  // (Dubaï) à l'écran avant le rebouclage → l'indicateur revient avec lui.
  if (f >= 0.98) return 0;
  let idx = 0;
  for (let i = 0; i < segments.length; i += 1) {
    if (f >= segments[i]) idx = i;
  }
  return idx;
}

export default function HeroTerritories({ lang = 'fr', active = 0 }) {
  const fr = lang === 'fr';
  return (
    <nav
      className="hidden md:flex items-stretch"
      aria-label={fr ? 'Territoires de la maison' : 'House territories'}
      data-testid="hero-territories"
    >
      {HERO_TERRITORIES.map((t, i) => {
        const [name, country] = fr ? t.fr : t.en;
        const isActive = i === active;
        const inner = (
          <span className="relative block py-3">
            <span
              className={`text-[12px] lg:text-[12.5px] tracking-[0.14em] uppercase font-medium transition-colors duration-700 ${
                isActive ? 'text-ivory' : 'text-ivory/50'
              }`}
            >
              {name}
            </span>
            <span
              className={`ml-2 text-[11px] lg:text-[11.5px] tracking-[0.02em] transition-colors duration-700 ${
                isActive ? 'text-ivory/75' : 'text-ivory/35'
              }`}
            >
              / {country}
            </span>
            <span
              className={`absolute left-0 right-6 bottom-0 h-[2px] bg-gold origin-left transition-transform duration-700 ease-out ${
                isActive ? 'scale-x-100' : 'scale-x-0'
              }`}
              aria-hidden
            />
          </span>
        );
        const sep = i > 0 ? (
          <span className="self-center h-6 w-px bg-ivory/15 mx-4 lg:mx-6" aria-hidden />
        ) : null;
        return (
          <span key={t.id} className="flex items-stretch" data-testid={`hero-territory-${t.id}`} data-active={isActive}>
            {sep}
            {t.pageKey ? (
              <Link
                to={localizedPath(t.pageKey, lang)}
                className="group focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gold/60"
                data-testid={`hero-territory-link-${t.id}`}
              >
                {inner}
              </Link>
            ) : (
              <span>{inner}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
